import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from "react-intl";

export class Toggle extends React.Component {
  constructor (props) {
    super(props);

    const { selectedValue } = this.props;

    this.state = {
      selectedValue,
      errorMsg: null
    }

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (event) {
    const selectedValue = event.target.value;

    this.setState({
      selectedValue,
      errorMsg: ''
    });

    if (this.props.changeCallback) {
      this.props.changeCallback(selectedValue);
    }
  }

  isValid () {
    const { selectedValue } = this.state;
    const { optional } = this.props;
    let errorFree = true;

    if (!selectedValue && !optional) {
      this.setState({ errorMsg: this.props.errorMsg || <FormattedMessage id="shared_components.toggle.select_option" defaultMessage="Please select an option."/> });
      errorFree = false;
    } else {
      this.setState({ errorMsg: '' });
    }

    return errorFree;
  }

  checkForError () {
    const { errorMsg } = this.state;

    if (errorMsg) {
      return <p className={"help-block inline-help text-danger text-left"}>{errorMsg}</p>;
    }
  }

  renderTitle () {
    const { title } = this.props;

    if (title) {
      return <h5>{ title }</h5>;
    }
  }

  renderLabel () {
    const { label } = this.props;

    if (label) {
      return <label className="control-label text-left vert-align-label">{ label }</label>;
    }
  }

  render () {
    const { selectedValue } = this.state;
    const { onValue, offValue, onLabel, offLabel, colSize } = this.props;

    return (
      <div>
        <div className="col-md-12">
          { this.renderTitle() }
          { this.renderLabel() }
        </div>
        <div className={ colSize }>
          <div className="switch">
            <input type="radio" className="switch-input" name="switcher" value={ onValue } id={ onValue } onChange={ this.handleChange } checked={ selectedValue === onValue } />
            <label htmlFor={ onValue } className="switch-label switch-label-on">{ onLabel }</label>
            <input type="radio" className="switch-input" name="switcher" value={ offValue} id={ offValue } onChange={ this.handleChange } checked={ selectedValue === offValue } />
            <label htmlFor={ offValue } className="switch-label switch-label-off">{ offLabel }</label>
          </div>
          { this.checkForError() }
        </div>
      </div>
    );
  }
}

Toggle.propTypes = {
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  onValue: PropTypes.string,
  offValue: PropTypes.string,
  changeCallback: PropTypes.func,
  title: PropTypes.string,
  label: PropTypes.string,
  colSize: PropTypes.string,
  errorMsg: PropTypes.string,
  optional: PropTypes.bool
};

Toggle.defaultProps = {
  onLabel: 'On',
  offLabel: 'Off',
  onValue: 'on',
  offValue: 'off',
  selectedValue: false,
  colSize: 'col-md-12',
  optional: false
};
